export const authTypes = {
  LOG_IN: "auth/LOG_IN",
  LOG_IN_SUCCESS: "auth/LOG_IN_SUCCESS",
  LOGIN_SUCCESS_LOCAL_STORAGE: "login/LOGIN_SUCCESS_LOCAL_STORAGE",
  LOG_OUT: "auth/LOG_OUT",
  LOG_OUT_SUCCESS: "auth/LOG_OUT_SUCCESS",
  REQUEST_LOGIN_CODE: "auth/REQUEST_LOGIN_CODE",
  REQUEST_LOGIN_CODE_SUCCESS: "auth/REQUEST_LOGIN_CODE_SUCCESS",
  VERIFY_LOGIN_CODE: "auth/VERIFY_LOGIN_CODE",
  VERIFY_LOGIN_CODE_SUCCESS: "auth/VERIFY_LOGIN_CODE_SUCCESS",
  AUTH_ERROR: "auth/AUTH_ERROR",
};

export const logIn = (payload) => ({
  type: authTypes.LOG_IN,
  payload,
});

export const requestLoginCode = (payload) => ({
  type: authTypes.REQUEST_LOGIN_CODE,
  payload,
});

export const verifyLoginCode = (payload) => ({
  type: authTypes.VERIFY_LOGIN_CODE,
  payload,
});

export const loginSuccessFromLocalStorage = (payload) => ({
  type: authTypes.LOGIN_SUCCESS_LOCAL_STORAGE,
  payload,
});

export const logOut = () => ({
  type: authTypes.LOG_OUT,
});
